import React from 'react';

import { Breakpoints, useIsMobile } from '@vw-marketing/us-components';

import {
  StyledBottomSection,
  StyledInnerLeftSection,
  StyledInnerLeftTopSection,
  StyledInnerRightBottomSection,
  StyledInnerRightSection,
  StyledInnerRightTopSection,
  StyledMlpSkeletonWrapper,
  StyledTopSection,
} from './styled';
import { SkeletonBox } from '../../../../components/skeleton-box';

export const SkeletonBoxes = () => {
  const isTablet: boolean = useIsMobile(Breakpoints.b1600);
  const isMobile: boolean = useIsMobile(Breakpoints.b960);

  return (
    <StyledMlpSkeletonWrapper>
      <StyledTopSection>
        <SkeletonBox
          isSalesEvent={true}
          height="12px"
          width={isMobile ? '64px' : '112px'}
        />
        {isMobile && (
          <SkeletonBox isSalesEvent={true} height="12px" width="112px" />
        )}
      </StyledTopSection>
      <StyledBottomSection>
        <StyledInnerLeftSection>
          <StyledInnerLeftTopSection>
            <SkeletonBox
              height="32px"
              isSalesEvent={true}
              responsiveWidth={{ mobile: '373px', tablet: '300px' }}
              width={isTablet ? '356px' : '447px'}
            />
            <SkeletonBox
              height="32px"
              isSalesEvent={true}
              responsiveWidth={{ mobile: '310px', tablet: '250px' }}
              width={isTablet ? '297px' : '373px'}
            />
          </StyledInnerLeftTopSection>
          <SkeletonBox
            height="16px"
            isSalesEvent={true}
            responsiveWidth={{ mobile: '137px', tablet: '120px' }}
            width={isTablet ? '143px' : '179px'}
          />
        </StyledInnerLeftSection>
        <StyledInnerRightSection>
          <StyledInnerRightTopSection>
            <SkeletonBox
              height="16px"
              isSalesEvent={true}
              responsiveHeight={{ mobile: '12px' }}
              responsiveWidth={{ mobile: '323px', tablet: '271px' }}
              width={isTablet ? '320px' : '402px'}
            />
            <SkeletonBox
              height="16px"
              isSalesEvent={true}
              responsiveHeight={{ mobile: '12px' }}
              responsiveWidth={{ mobile: '373px', tablet: '328px' }}
              width={isTablet ? '388px' : '488px'}
            />
            <SkeletonBox
              height="16px"
              isSalesEvent={true}
              responsiveHeight={{ mobile: '12px' }}
              responsiveWidth={{ mobile: '278px', tablet: '232px' }}
              width={isTablet ? '275px' : '346px'}
            />
          </StyledInnerRightTopSection>
          <StyledInnerRightBottomSection>
            <SkeletonBox
              height="32px"
              isSalesEvent={true}
              responsiveHeight={{ mobile: '24px' }}
              responsiveWidth={{ mobile: '180px' }}
              width="160px"
            />
            <SkeletonBox
              height="20px"
              isSalesEvent={true}
              responsiveHeight={{ mobile: '16px' }}
              responsiveWidth={{ mobile: '140px' }}
              width="140px"
            />
          </StyledInnerRightBottomSection>
        </StyledInnerRightSection>
      </StyledBottomSection>
    </StyledMlpSkeletonWrapper>
  );
};
